import { Company } from 'api/models';
import { CompanyOption, NewCompanyOption } from '../types';

export const companyOption = (company: Company): CompanyOption => {
  return {
    label: company.companyName,
    value: company.companyId,
    imageUrl: company.companyLogoUrl,
  };
};

export const getNewCompanyOption = (companyName: string): NewCompanyOption => ({
  label: companyName,
  value: companyName,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  __isNew__: true,
});

export const getCompanyValue = (
  companyNameInput: string,
  vendorCompanyName: string,
  existingCompanies?: Company[],
) => {
  const existingCompany = existingCompanies?.find(
    (company) =>
      company.companyName.toLowerCase() === companyNameInput.toLowerCase(),
  );

  if (existingCompany) {
    return companyOption(existingCompany);
  }

  if (companyNameInput) {
    const newCustomerComapnyName =
      companyNameInput.toLowerCase() === vendorCompanyName.toLowerCase()
        ? `${companyNameInput}--internal`
        : companyNameInput;

    return getNewCompanyOption(newCustomerComapnyName);
  }

  return undefined;
};
